import {Pipe, PipeTransform} from '@angular/core';
import {
    IPlaybookGuidelineRunItem,
    PlaybookGuidelineStatusEnum
} from "./plyabbok-guideline-run-tile/playbook-guideline-run-tile.component";
import {IGuideLineListFilter} from "./playbook-list.component";

const guideLineFilterMap = {
    [PlaybookGuidelineStatusEnum.MISSING] : [PlaybookGuidelineStatusEnum.MISSING, PlaybookGuidelineStatusEnum.PROCESSING, PlaybookGuidelineStatusEnum.FAILED]
}

@Pipe({
  name: 'guidelineListFilter',
  standalone: true
})
export class GuidelineListFilterPipe implements PipeTransform {

  transform(guideLines: IPlaybookGuidelineRunItem[], filters:IGuideLineListFilter): IPlaybookGuidelineRunItem[] {
    if(Array.isArray(guideLines) && filters){
        return guideLines.filter(guideLine => this.filterByStatus(guideLine, filters))
    }

    return guideLines;
  }

  private filterByStatus(item:IPlaybookGuidelineRunItem, filters:IGuideLineListFilter):boolean{
        if(filters?.status?.length > 0 && item?.status!= PlaybookGuidelineStatusEnum.PROCESSING){
          return filters.status.includes(item.status);
      }

      return true;
  }
}
